import { HeaderStyleEnum } from "./types";

export const HeaderStyle = {
  [HeaderStyleEnum.default]: {
    titleColor: "$textDark900",
    leftColor: "$primary700",
    rightColor: "$primary700",
    backgroundColor: "$backgroundLight0"
  },
  [HeaderStyleEnum.dark]: {
    titleColor: "$white",
    leftColor: "$white",
    rightColor: "$white",
    backgroundColor: "$secondary900"
  },
  [HeaderStyleEnum.grey]: {
    titleColor: "$textDark900",
    leftColor: "$primary700",
    rightColor: "$primary700",
    backgroundColor: "$backgroundLight50"
  },
  [HeaderStyleEnum.light]: {
    titleColor: "$textDark900",
    leftColor: "$primary700",
    rightColor: "$primary700",
    backgroundColor: "$backgroundLight0"
  },
  [HeaderStyleEnum.transparent]: {
    titleColor: "$white",
    leftColor: "$white",
    rightColor: "$white",
    backgroundColor: "transparent"
  },
  [HeaderStyleEnum.primary]: {
    titleColor: "$white",
    leftColor: "$white",
    rightColor: "$white",
    backgroundColor: "$primary700"
  }
};
